<ng-container rtBlock="sc-calc-placeholder-page">
    <div rtElem="frame">
        <span rtElem="tag" i18n="@@calcPlaceholderTag">В разработке</span>
        <h1 rtElem="title">{{ label() }}</h1>
        <p rtElem="lead" i18n="@@calcPlaceholderLead">Этот тип лестницы скоро появится. Пока доступна прямая — попробуйте её.</p>
        <a rtElem="cta" routerLink="/calc/straight" i18n="@@calcPlaceholderCta">Открыть прямую</a>
    </div>
</ng-container>
